module.exports = __webpack_public_path__ + "img/LB.ed6c00bb.svg";